import { defineComponent, unref, resolveComponent, ref } from 'vue';import "core-js/modules/es.array.includes.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { useStore } from 'vuex';
import { setBrowser } from '@/common-ts/utils';
import { setBackgroundImage, setTheme } from '@/theme/themeChalk';
import { receiveMessage } from '@/common-ts/postMessage';
import { onMounted } from 'vue';
import { initToAgentMF } from '@/common-ts/toAgentMF';
export default /*#__PURE__*/_defineComponent({
  __name: 'App',

  setup(__props) {
    onMounted(() => {
      receiveMessage();
      initToAgentMF();
    }); // 使用vuex

    const store = useStore();

    if (!window.location.href.includes('webview') && !window.location.href.includes('guide')) {
      // 获取缓存中的主题名称
      // const theme = getCookie('theme')
      // 获取缓存中的背景图片url
      // const background = getCookie('background')
      // 获取库中的主题数据
      const defaultThemeData = store.getters['global/pageConfig'].basePageConfig.theme; // 获取库中的背景数据

      const backgroundData = store.getters['global/pageConfig'].basePageConfig.backgroundConfig; // 获取库中的浏览器title和icon

      const browser = store.getters['global/pageConfig'].basePageConfig.browserLabelConfig; // 判断传入字符串是否包含在这个数组中
      // const isContain = (arr:any[], str:string) => {
      // // 将arr转为字符串
      //   const arrStr = JSON.stringify(arr)
      //   // 判断arrStr中是否包含str
      //   return arrStr.indexOf(str) > -1
      // }

      console.log(document.title); // 智联项目特殊处理

      if (!document.title) {
        // 设置浏览器icon和title
        setBrowser(browser);
      } // 设置主题，优先读取cookie中存储的主题，其次使用返回的默认主题
      // setTheme(isContain(defaultThemeData.options, theme) ? theme : defaultThemeData.default)
      // 设置主题


      setTheme(defaultThemeData.default); // 设置背景图片，优先读取cookie中存储的背景图片，其次使用返回的默认背景

      if (store.getters['global/tmplMark'] !== 'mobile') {
        // setBackgroundImage(isContain(backgroundData.options, background) ? background : backgroundData.default)
        setBackgroundImage(backgroundData.default);
      }
    } else {
      setTheme();
    } // 对数组中的值每次取出一个，如果数组为空，则取出数组中的第一个值


    let index = 0;
    const array = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

    const getNext = arr => {
      if (index >= arr.length) {
        index = 0;
      }

      return array[index++];
    };

    getNext(array);
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");

      const _component_el_config_provider = _resolveComponent("el-config-provider");

      return _openBlock(), _createBlock(_component_el_config_provider, {
        locale: _unref(store).getters['global/i18nElement']
      }, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      }, 8, ["locale"]);
    };
  }

});